import { render, staticRenderFns } from "./dynamic-document-text-field-template.vue?vue&type=template&id=178c128a&scoped=true&"
import script from "./dynamic-document-text-field-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-text-field-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-text-field-template.vue?vue&type=style&index=0&id=178c128a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178c128a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VBtnToggle,VList,VListItem,VListItemTitle,VMenu})
